import React, { useState } from "react";

const steps = [
  {
    icon: "🌍",
    title: "Welcome to e-save!",
    description:
      "You're making a real difference by recycling your old electronics. This quick guide will show you how to get started in under a minute.",
    action: "Let's go →",
  },
  {
    icon: "🗺️",
    title: "Find a Collection Centre",
    description:
      "Head to the Map to see e-waste collection centres near you. Click any green marker to view details, opening hours, and directions.",
    action: "Next →",
    link: "/map",
    linkLabel: "Open Map",
  },
  {
    icon: "📦",
    title: "Submit a Recycling Request",
    description:
      "Click on a centre and use the 'Request Collection' form to tell us what device you're recycling. We'll confirm it within 24 hours.",
    action: "Next →",
  },
  {
    icon: "⭐",
    title: "Earn Reward Points",
    description:
      "Every device you recycle earns you points. The more you recycle, the higher your Eco Saver level — from Eco Starter all the way to Platinum Saver!",
    action: "Next →",
  },
  {
    icon: "🎁",
    title: "Redeem Your Rewards",
    description:
      "Use your points to claim rewards in the Rewards section. Check your Dashboard any time to track your impact and recycling history.",
    action: "Got it, let's go! 🚀",
  },
];

const OnboardingGuide = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      localStorage.setItem("esave_onboarding_seen", "true");
      onClose();
    }
  };

  const handleSkip = () => {
    localStorage.setItem("esave_onboarding_seen", "true");
    onClose();
  };

  const step = steps[currentStep];

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-60 px-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 relative">
        <button
          onClick={handleSkip}
          className="absolute top-4 right-5 text-gray-400 hover:text-gray-600 text-2xl font-light"
        >
          ×
        </button>

        <div className="text-center mb-6">
          <div className="text-5xl mb-4">{step.icon}</div>
          <h2 className="text-2xl font-bold text-[#172A3A] mb-3">{step.title}</h2>
          <p className="text-[#6C757D] text-sm leading-relaxed">{step.description}</p>
        </div>

        {step.link && (
          <div className="flex justify-center mb-4">
            <a
              href={step.link}
              className="flex items-center bg-[#004d3f] text-white px-5 py-2 rounded-full text-sm hover:bg-[#29752B] transition"
            >
              {step.linkLabel}
            </a>
          </div>
        )}

        <div className="flex items-center justify-between mt-2">
          <div className="flex space-x-2">
            {steps.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentStep(i)}
                className={`w-2.5 h-2.5 rounded-full transition-all ${
                  i === currentStep ? "bg-[#29752B] w-6" : "bg-gray-300"
                }`}
              />
            ))}
          </div>

          <div className="flex items-center space-x-3">
            {currentStep < steps.length - 1 && (
              <button
                onClick={handleSkip}
                className="text-sm text-gray-400 hover:text-gray-600"
              >
                Skip
              </button>
            )}
            <button
              onClick={handleNext}
              className="bg-[#29752B] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#18421B] transition"
            >
              {step.action}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingGuide;
